import { render } from "./fldsRadarChart.vue?vue&type=template&id=b549eb88&scoped=true"
import script from "./fldsRadarChart.vue?vue&type=script&lang=js"
export * from "./fldsRadarChart.vue?vue&type=script&lang=js"

import "./fldsRadarChart.vue?vue&type=style&index=0&id=b549eb88&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b549eb88"]])

export default __exports__